import axios from 'axios'
import fileSaver from 'file-saver'

export default{
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getResources ({commit, state, rootState}, args) {
      var eventPath = args.eventId !== undefined ? `events/${args.eventId}/` : ''
      var apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/${eventPath}resources`
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getResourcesByFolderId ({commit, state, rootState}, args) {
      console.log('args: ' + JSON.stringify(args, null, 2))

      var apiPath = ''
      var eventPath = args.eventId !== undefined ? `events/${args.eventId}/` : ''
      if (args.folderType.toLowerCase() === 'property' && args.propertyId === null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/${eventPath}resources/properties`
      } else if (args.folderType.toLowerCase() === 'property' && args.propertyId !== null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/${eventPath}resources/folders/${args.folderId}`
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/${eventPath}resources/folders/${args.folderId}`
      }

      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getFolderForEdit ({rootState}, args) {
      var apiPath = ''
      var eventPath = args.eventId !== undefined ? `events/${args.eventId}/` : ''

      if (args.propertyId === null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/${eventPath}resources/folders/${args.folderId}/edit`
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/${eventPath}resources/folders/${args.folderId}/edit`
      }
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async saveFolder ({rootState}, args) {
      console.log('Saving folder: ' + JSON.stringify(args.folder, null, 2))
      var apiPath = ''

      if (args.folder.eventId !== undefined) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.folder.eventId}/resources/folders/save`
      } else if (args.folder.propertyId === null || args.folder.propertyId === undefined) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/resources/folders/save`
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.folder.propertyId}/resources/folders/save`
      }
      return axios.post(apiPath, args.folder).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    // Documents
    uploadDocument ({rootState}, args) {
      console.log('Upload clicked. for event: ' + args.name)
      console.log('stringify ', JSON.stringify(args, null, 2))
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/resources/folders/${args.folderId}/documents/${encodeURIComponent(args.fileName)}/${args.documentTypeId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/documents/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/documents/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {name: args.name, note: args.note}
        })
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    async downloadDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for document:', args.documentId)
      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/documents/${args.documentId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    async deleteDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Delete clicked for document: ' + args.name)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/documents/${args.documentId}`
      }
      return axios.delete(apiPath, {params: {shouldPermanentlyDelete: false}})
        .then((result) => {
          return result.data
        }).catch(error => {
          console.log(error)
        })
    },
    moveDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Move clicked for document: ' + args.documentId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}/move`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}/move`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/documents/${args.documentId}/move`
      }
      return axios.get(apiPath, {params: {folderId: args.folderId}})
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    // Images
    uploadImage ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for image: ' + args.name)
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/resources/folders/${args.folderId}/images/${encodeURIComponent(args.fileName)}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/images/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/images/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {name: args.name, note: args.note}
        })
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    async downloadImage ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for image:', args.imageId)
      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/images/${args.imageId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/images/${args.imageId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    async deleteImage ({commit, state, rootState, dispatch}, args) {
      console.log('Delete clicked for image: ' + args.name)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/images/${args.imageId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/images/${args.imageId}`
      }
      return axios.delete(apiPath, {params: {shouldPermanentlyDelete: false}})
        .then((result) => {
          return result.data
        }).catch(error => {
          console.log(error)
        })
    },
    moveImage ({commit, state, rootState, dispatch}, args) {
      console.log('Move clicked for document: ' + args.imageId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/images/${args.imageId}/move`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}/move`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/images/${args.imageId}/move`
      }
      return axios.get(apiPath, {params: {folderId: args.folderId}})
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    // Videos
    uploadVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for video: ' + args.name)
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/resources/folders/${args.folderId}/videos/${encodeURIComponent(args.fileName)}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/videos/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/videos/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {name: args.name, note: args.note}
        })
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    async downloadVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for video:', args.videoId)
      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/videos/${args.videoId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/videos/${args.videoId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    async deleteVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Delete clicked for video: ' + args.name)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/videos/${args.videoId}`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/videos/${args.videoId}`
      }
      return axios.delete(apiPath, {params: {shouldPermanentlyDelete: false}})
        .then((result) => {
          return result.data
        }).catch(error => {
          console.log(error)
        })
    },
    moveVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Move clicked for video: ' + args.videoId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/videos/${args.videoId}/move`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}/move`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/videos/${args.videoId}/move`
      }
      return axios.get(apiPath, {params: {folderId: args.folderId}})
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    getMoveFoldersForDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Getting move folders for: ' + args.documentId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}/move/folders`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}/move/folders`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/documents/${args.documentId}/move/folders`
      }
      return axios.get(apiPath)
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    getMoveFoldersForImage ({commit, state, rootState, dispatch}, args) {
      console.log('Getting move folders for: ' + args.imageId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/images/${args.imageId}/move/folders`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}/move/folders`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/images/${args.imageId}/move/folders`
      }
      return axios.get(apiPath)
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    getMoveFoldersForVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Getting move folders for: ' + args.videoId)

      var apiPath = ''
      if (args.eventId !== undefined && args.eventId !== null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/videos/${args.videoId}/move/folders`
      } else if (args.propertyId === null) {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}/move/folders`
      } else {
        apiPath = `${process.env.API_URL}api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/videos/${args.videoId}/move/folders`
      }
      return axios.get(apiPath)
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    async getAcceptedFileTypes ({commit, state, rootState, dispatch}, args) {
      console.log('getting accepted document types')
      // types: 1 = document, 2 = image, 3 = video
      const types = [
        // Documents
        {type: 1, ext: 'pdf', class: 'fas fa-file-pdf', color: 'rgb(244, 15, 2)'},
        {type: 1, ext: 'xlsx', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'xls', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'csv', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'ppt', class: 'fas fa-file-powerpoint', color: 'rgb(204, 85, 0)'},
        {type: 1, ext: 'pptx', class: 'fas fa-file-powerpoint', color: 'rgb(204, 85, 0)'},
        {type: 1, ext: 'docx', class: 'fas fa-file-word', color: 'rgb(64, 114, 196)'},
        {type: 1, ext: 'doc', class: 'fas fa-file-word', color: 'rgb(64, 114, 196)'},
        {type: 1, ext: 'txt', class: 'fas fa-file', color: 'rgb(92, 92, 92)'},
        // Images
        {type: 2, ext: 'jpg', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'jpeg', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'gif', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'png', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'heic', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'heif', class: 'fas fa-image', color: 'blue'},
        // Videos
        {type: 3, ext: 'mov', class: 'fas fa-video', color: 'orange'},
        {type: 3, ext: 'mp4', class: 'fas fa-video', color: 'orange'},
        {type: 3, ext: 'webm', class: 'fas fa-video', color: 'orange'}
      ]

      return new Promise(resolve => {
        resolve(types)
      })
    }
  }
}
